import { render, staticRenderFns } from "./AnnouncementAlert.vue?vue&type=template&id=3770c399&"
import script from "./AnnouncementAlert.vue?vue&type=script&lang=js&"
export * from "./AnnouncementAlert.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports